import { makeAutoObservable } from 'mobx'

export class TopBarState implements ITopBarState {

    constructor() {
        makeAutoObservable(this)
    }
    // 标题 e.g 集团管理 餐厅管理
    title: string = '';
    // 副标题 e.g 集团名称 餐厅名称
    subTitle: string = '';

    /**
     * 初始化
     */
    // init = () => {

    // }

    /**
     * 销毁
     */
    clearTitle = () => {
        this.title = '';
        this.subTitle = '';
    }

    updateTitle(value: string) {
        this.title = value;
    }

    updateSubTitle(value: string) {
        this.subTitle = value;
    }

    // 集团管理
    updateGroupTitle(value: string) {
        this.title = 'main_page_text_group_management';
        this.subTitle = value;
    }

    // 餐厅隧道管理
    updateTunnelManageTitle() {
        this.title = 'tunnel_management_page_text_restaurant_tunnel_management';
        this.subTitle = '';
    }

    // 餐厅隧道管理
    updateQOPTunnelManageTitle() {
        this.title = 'qop_tunnel_management_page_text_restaurant_tunnel_management';
        this.subTitle = '';
    }

    // 餐厅管理
    updateRestaurantTitle(value: string) {
        this.title = 'restaurant_management_page';
        this.subTitle = value;
    }

    // 敏感操作记录
    updateOperateRecordTitle() {
        this.title = 'operation_record_sensitive_operation_record';
        this.subTitle = '';
    }

    // 资源回收站
    updateDeletedResourceTitle() {
        this.title = 'main_page_text_recycle_bin';
        this.subTitle = '';
    }

    // 帮助中心
    updateHelperCenterTitle() {
        this.title = 'help_center_page_text_help_center'
        this.subTitle = '';
    }

    // 我的账户（与设计稿、my_account 文案 key 一致）
    updateMyAccountTitle() {
        this.title = 'my_account_tab_my_account';
        this.subTitle = '';
    }

    // 营业分析
    updateDataAnalysisTitle() {
        this.title = 'business_analysis_page_text_business_analysis';
        this.subTitle = '';
    }

    // Deliverect平台日志
    updateDeliverectTitle() {
        this.title = 'deliverect_setting_page_text';
        this.subTitle = '';
    }


    // 经销商
    updateResellerTitle(value: string) {
        this.title = 'reseller_page_text_reseller_list';
        this.subTitle = value;
    }

    // 余额明细
    updateResellerConsumptionTitle(value: string) {
        this.title = 'reseller_page_text_reseller_consumption_list';
        this.subTitle = value;
    }

    // 产品列表
    updateProductionTitle(value: string) {
        this.title = 'product_list_page_product_list';
        this.subTitle = value;
    }

    // 产品信息
    updateProductionInfoTitle(value: string) {
        this.title = 'product_list_page_product_detail';
        this.subTitle = value;
    }

    // Fiskaly 设置
    updateFiskalySettingTitle() {
        this.title = 'fiskaly_setting_page_text';
        this.subTitle = '';
    }
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ITopBarState {

}